<template>
    <div>
        <header class="bg-gray-100 text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 flex flex-col md:flex-row-reverse" style="max-width: 1800px">
                <div class="md:w-72 mb-12 md:mb-0 md:ml-8 lg:ml-12">
                    <img src="https://insync.software/mobile-img/logo.svg" class="h-12">
                    <div class="mt-4">
                        <p class="font-semibold mb-1">Hambro Roofing Limited</p>
                        <p>Unit 2, 6-10 Lamson Road Rainham Essex RM13 9YY</p>
                        <p><a href="tel:01708803930">01708 803 930</a></p>
                        <p><a href="http://www.hambroroofing.com">www.hambroroofing.com</a></p>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-8">
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Date:</h2>
                            <p class="mt-1 text-gray-500">{{ moment(dayworksSheet.date).format('DD/MM/YYYY') }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Package:</h2>
                            <p class="mt-1 text-gray-500">{{ dayworksSheet.packageName }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Location of Works:</h2>
                            <p class="mt-1 text-gray-500">{{ dayworksSheet.locationOfWorks }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Name:</h2>
                            <p class="mt-1 text-gray-500">{{ dayworksSheet.name }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="bg-white text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 pb-16 lg:pb-16 flex flex-col-reverse lg:flex-row-reverse"
                 style="max-width: 1800px">
                <div class="lg:w-72 mb-12 lg:mb-0 lg:ml-12 ">
                    <div class="space-y-8 sticky top-4">
                        <div v-if="dayworksSheet.status==='Approved'">
                            <h2 class="font-semibold text-lg text-gray-700">Dayworks Sheet Approved</h2>
                            <p class="text-sm mt-1">This Dayworks Sheet has been approved</p>
                            <div class="hidden lg:block" v-if="dayworksSheet.response">
                                <p class="text-sm mt-1" v-if="dayworksSheet.response">Approved by: <span
                                    class="font-semibold">{{ dayworksSheet.response.name }}</span></p>
                                <p class="text-sm mt-1" v-if="dayworksSheet.response">Signed:</p>
                                <img v-if="dayworksSheet.response.signature" :src="dayworksSheet.response.signature"
                                     style="width:100%; margin: 5px">
                            </div>
                        </div>
                        <div v-else-if="dayworksSheet.status==='Rejected'">
                            <h2 class="font-semibold text-lg text-gray-700">Rejected</h2>
                            <p class="text-sm mt-1">This Dayworks Sheet has been rejected</p>
                            <p class="text-sm mt-1" v-if="dayworksSheet.response">Rejected by: <span
                                class="font-semibold">{{ dayworksSheet.response.name }}</span></p>
                        </div>
                        <div v-else-if="type==='approve'">
                            <div @click="approve"
                                 class="mt-6 flex items-center justify-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white hover:text-white bg-gray-700 hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                                <i class="fa fa-check mr-2"></i>
                                I approve this Dayworks Sheet
                            </div>
                            <div @click="reject"
                                 class="mt-2 flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-red-600 hover:text-red-600 bg-transparent hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
                                <i class="fa fa-times mr-2 text-red-400"></i>
                                I reject this Dayworks Sheet
                            </div>
                        </div>
                        <div v-else>
                            Dayworks Sheet has not been approved
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="text-3xl font-semibold text-gray-900"
                         v-text="'Dayworks Sheet '+dayworksSheet.referenceNumber"></div>
                    <div class="mb-8 text-gray-500">
                        <span class="font-semibold"
                              v-text="'Reference : '+dayworksSheet.packageReference+' • '+dayworksSheet.referenceNumber"></span>
                    </div>
                    <div class="text-xl font-semibold text-gray-900 mt-4">Description of Works</div>
                    <div class="text-gray-700" v-text="dayworksSheet.descriptionOfWorks"></div>
                    <div class="text-xl font-semibold text-gray-900 mt-4">Will impact ths programme?</div>
                    <div class="text-gray-700" v-text="dayworksSheet.willImpactProgramme?'Yes':'No'"></div>
                    <div class="mt-6">
                        <div class="text-xl font-semibold text-gray-900 mt-4">Dayworks Breakdown</div>
                        <div
                            class="flex mt-4 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                            <div class="w-6 flex-shrink-0"></div>
                            <div class="border-l border-r border-gray-200 px-2 py-1 w-1/4">Type</div>
                            <div class="border-r border-gray-200 px-2 py-1 flex-grow">Description</div>
                            <div class="-ml-px border-r border-gray-200 px-2 py-1 w-1/4">Qty</div>
                            <div class="w-6 flex-shrink-0 ml-2"></div>
                        </div>
                        <dayworks-breakdown-item v-for="(item,key) in dayworksSheet.breakdown" :key="item.index"
                                                 :item="item"
                                                 :readonly="true"
                        ></dayworks-breakdown-item>
                    </div>
                    <div class="mt-6" v-if="getDayworksFiles().length">
                        <div class="text-xl font-semibold text-gray-900 mt-4 mb-4">Images, Videos and PDFs</div>
                        <ui-input-file-inline name="media[]"
                                              :readonly="true"
                                              :downloadUrl="downloadUrl"
                                              :current-files="getDayworksFiles"></ui-input-file-inline>
                    </div>
                    <div v-if="dayworksSheet.response && dayworksSheet.response.signature" class="lg:hidden block mt-4">
                        <p class="text-sm mt-1" v-if="dayworksSheet.response">Approved by: <span
                            class="font-semibold">{{ dayworksSheet.response.name }}</span></p>
                        <p class="text-sm mt-1" v-if="dayworksSheet.response">Signed:</p>
                        <img v-if="dayworksSheet.response.signature" :src="dayworksSheet.response.signature"
                             style="width:100%; margin: 5px; max-width: 350px">
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import moment from "moment";
import UiDropdown from "../../../ui/UiDropdown.vue";
import UiTextarea from "../../../ui/UiTextarea.vue";
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import DayworksBreakdownItem from "../DayworksBreakdownItem.vue";

export default {
    components: {DayworksBreakdownItem, UiDropdownItem, UiTextarea, UiDropdown},
    props: {
        type: String,
        dayworksSheet: Object,
    },
    data() {
        return {moment}
    },
    computed: {},
    methods: {
        downloadUrl(id) {
            return route('api.v2.external.dayworks-sheet.file.download', {
                'id': this.dayworksSheet.id,
                'file_id': id
            }) + '?type=' + this.type + '&jwt=' + ((window.auth && window.auth.token) ? window.auth.token : '')
        },
        getDayworksFiles() {
            return this.dayworksSheet.files
        },
        print(url) {
            if (!this.iframe) {
                this.iframe = document.createElement('iframe');
                this.iframe.setAttribute('style', 'display:none');
                this.iframe.src = "";
                this.iframe.name = 'pdf';
                this.iframe.onload = () => {
                    this.$nextTick(() => {
                            setTimeout(() => {
                                const pdfFrame = window.frames["pdf"];
                                pdfFrame.focus();
                                pdfFrame.print();
                            }, 100)
                        }
                    )
                }
                document.body.appendChild(this.iframe);
            }
            this.iframe.src = url + '?time=' + moment().format('x')
        },
        download() {
            window.location.href = this.dayworksSheet.getDownloadUrl()
        },
        approve() {
            this.$modals.open('dayworks-sheet-approve', {
                title: `Approve this Dayworks Sheet`,
                button: 'I approve this Dayworks Sheet',
                handle: async (data, modal) => {
                    await Http.post(window.location.href, {name: data.name, signature: data.signature})
                    window.location.reload()
                }
            })
        },
        reject() {
            this.$modals.open('dayworks-sheet-reject', {
                title: `Reject this Dayworks Sheet`,
                button: 'I reject this Dayworks Sheet',
                handle: async (data, modal) => {
                    await Http.post(window.location.href, {name: data.name, comment: data.comment})
                    window.location.reload()
                }
            })
        },
    },
    async mounted() {
    },
}
</script>
